<template>
  <section
    class="banners"
    :class="{ mobile: mobile_view, desktop: !mobile_view }"
  >
    <slick
      ref="slick"
      :options="options"
      @afterChange="handleAfterChange"
    >
      <div
        v-for="(banner, i) in banners"
        :id="`banner-${i}`"
        :key="`banner-${i}`"
        class="banner-item"
        :class="{ active: currentSlide === i }"
      >
        <template v-if="!banner.url">
          <!-- <div class="img_container" v-lazy-container="{ selector: 'img' }">
            <img
              class="w-100"
              :data-src="getAssetLink(banner.image)"
              :data-loading="$config.lazyload.slide"
              :data-error="$config.lazyload.slide"
            >
          </div>-->
          <div class="img_container">
            <img
              class="w-100"
              :src="getAssetLink(banner.image)"
            >
          </div>
        </template>
        <b-link
          v-else
          class="d-block"
          v-bind="isExternalLink(banner.url)? { href: banner.url, target: '_blank'}: { to: banner.url}"
        >
          <div
            v-lazy-container="{ selector: 'div' }"
            class="bg_container"
          >
            <div
              v-show="!mobile_view"
              v-lazy:background-image="getLazyLoadObj(banner.image)"
              data-loading
              :title="banner.headline"
            />
            <div
              v-show="mobile_view"
              v-lazy:background-image="getLazyLoadObj(banner.image_mobile)"
              data-loading
              :title="banner.headline"
            />
          </div>
        </b-link>
      </div>
    </slick>
  </section>
</template>
<script>
import Slick from "vue-slick";

export default {
  name: "Banners",
  components: { Slick },
  props: ["banners", "options"],
  data() {
    return {
      loading: true,
      mobile_view: false,
      default_image: this.$config.lazyload.banner,
      currentSlide: 0
    };
  },
  mounted: function() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
    setTimeout(() => {
      this.loading = false;
    }, 500);
  },
  methods: {
    onResize() {
      if (document.documentElement.clientWidth > 640) {
        this.mobile_view = false;
        this.default_image = this.$config.lazyload.banner;
      } else {
        this.mobile_view = true;
        this.default_image = this.$config.lazyload.banner_mobile;
      }
    },
    getLazyLoadObj(src) {
      return {
        src: this.getAssetLink(src),
        error: this.default_image,
        loading: this.default_image
      };
    },
    handleAfterChange(event, slick, currentSlide) {
      this.currentSlide = currentSlide;
    }
  }
};
</script>
<style src='slick-carousel/slick/slick.css'></style>
<style lang="scss" src='../assets/scss/banners.scss'></style>